import { styled, Box, Tabs, Paper } from '@mui/material';

export const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100vh',
    backgroundColor: '#f9f9f9',
});

export const BodyWrapper = styled(Box)({
    display: 'flex',
    flex: 1,
    height: '100%',
    overflow: 'hidden',
});

export const ContentWrapper = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    margin: '16px',
    overflow: 'hidden',
    minWidth: 0,
});

export const StyledTabs = styled(Tabs)({
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '16px',
    '& .MuiTab-root': {
        fontWeight: 600,
        textTransform: 'none',
        minHeight: '48px',
    },
    '& .Mui-selected': {
        color: '#015682',
    },
    '& .MuiTabs-indicator': {
        backgroundColor: '#0900aeff',
        height: '3px',
        borderRadius: '3px',
    },
});

export const TabContent = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: '8px',
    height: '100%',
    minWidth: 0,
});

export const TabPanelWrapper = styled(Paper)({
    flex: 1,
    padding: '20px',
    borderRadius: '12px',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    overflowY: 'auto',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
});
